import { Skeleton } from '@material-ui/lab';
import { Fragment } from 'react/jsx-runtime';
import { Hidden } from '@material-ui/core';

const MeLoadingSkeleton = () => {
  return (
    <Fragment>
      <Hidden mdUp>
        <Skeleton variant="rect" width={'100%'} height={300} style={{ borderRadius: '8px' }} />
      </Hidden>
      <Hidden smDown>
        <Skeleton variant="rect" width={'100%'} height={200} style={{ borderRadius: '8px' }} />
      </Hidden>
      <Skeleton variant="rect" width={'100%'} height={500} style={{ borderRadius: '8px', marginTop: '10px' }} />
    </Fragment>
  );
};

export default MeLoadingSkeleton;
